import datepicker from 'js-datepicker'

export default {
    _lists: null,
   

    init() {
        this._list = document.getElementsByClassName("date");
        for (const list of this._list) {
            const picker = datepicker(list.querySelector('input'), {
                customDays: ['Søn','Man', 'Tir', 'Ons', 'Tur', 'Fre', 'Lør'],
                customMonths: ['Jan', 'Feb', 'Mars', 'April', 'May', 'Juni', 'Juli', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],

                formatter: (input, date, instance) => {
                    const value = date.toLocaleDateString()
                    input.value = value.replaceAll("/", "-") // => '1/1/2099'
                }
            });
            picker.calendarContainer.style.setProperty('font-size', '18px')
            picker.calendarContainer.style.setProperty('border', 'none')
        }
    }
}
